import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "select2"

export default class extends Controller {
  static targets = ["dropdown", "viewReport"]

  connect() {
    if (!$(this.dropdownTarget).hasClass("select2-hidden-accessible")) {
      $(this.dropdownTarget).select2({
        dropdownParent: $('#selectCourseModal'),
        width: '100%',
        placeholder: "Select Course"
      })
    }

    this.updateLink()
    $(this.dropdownTarget).on('change', this.updateLink.bind(this))
  }

  disconnect() {
    if ($(this.dropdownTarget).hasClass("select2-hidden-accessible")) {
      $(this.dropdownTarget).select2('destroy')
    }
  }

  updateLink() {
    const dropdown = this.dropdownTarget
    const viewReport = this.viewReportTarget
    const selected = dropdown.options[dropdown.selectedIndex]
    const courseId = selected.value
    const courseName = selected.getAttribute('data-name') || ''
    const startDate = viewReport.dataset.startDate
    const endDate = viewReport.dataset.endDate
    const subdomain = viewReport.dataset.subdomain

    if (courseId) {
      const url = `/document_sets/${courseId}/usage_report?start_date=${startDate}&end_date=${endDate}&subdomain=${subdomain}`
      viewReport.href = url
      viewReport.onclick = (e) => {
        $('#selectCourseModal').modal('hide')
        if (window.analytics) {
          analytics.track('view_report_buttons', {
            page: window.location.href,
            source: 'Reports',
            report_name: 'Course Report'
          })
        }
      }
      viewReport.classList.remove('disabled')
    } else {
      viewReport.href = "#"
      viewReport.onclick = function() { return false }
      viewReport.classList.add('disabled')
    }
  }
}
